import { type ReactNode } from 'react'
import { Avatar } from 'antd'
import type { AvatarConfig } from '@super-mega/server/contracts/profile'
import { cn } from '@/utils/index.ts'
import { DEFAULT_AVATAR_SIZE, getUserAvatarDataUri } from './avatar-options.ts'

export type UserAvatarProps = {
  name: string
  avatar?: AvatarConfig | null
  size?: number
  alt?: string
  className?: string
}

function getNameInitial(name: string) {
  return name.trim().slice(0, 1).toUpperCase() || '账'
}

export function UserAvatar({ name, avatar, size = DEFAULT_AVATAR_SIZE, alt, className }: UserAvatarProps) {
  const resolvedAlt = alt ?? (name ? `${name}的头像` : '用户头像')
  const src = avatar ? getUserAvatarDataUri({ avatar, size }) : undefined

  return (
    <Avatar
      {...(!src ? { 'aria-label': resolvedAlt, role: 'img' } : {})}
      alt={resolvedAlt}
      className={cn('shrink-0 select-none', !src && 'bg-surface-muted! text-content-muted!', className)}
      draggable={false}
      size={size}
      src={src}
    >
      {src ? null : getNameInitial(name)}
    </Avatar>
  )
}

export type UserAvatarNameProps = {
  name: string
  isSystem?: boolean
  avatar?: AvatarConfig | null
  secondary?: ReactNode
  size?: number
  className?: string
}

export function UserAvatarName({
  name,
  avatar,
  secondary,
  size = 32,
  className,
  isSystem = false
}: UserAvatarNameProps) {
  if (isSystem) {
    return <span className={cn('text-content-muted text-sm', className)}>系统</span>
  }
  return (
    <div className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <UserAvatar avatar={avatar} name={name} size={size} />
      <span className="min-w-0">
        <span className="text-content block truncate text-sm">{name}</span>
        {secondary ? <span className="text-content-soft mt-0.5 block truncate text-xs">{secondary}</span> : null}
      </span>
    </div>
  )
}
